import { atom } from 'jotai';

// Live Director chat — an "Instruct about this" click on a clip/keyframe/music tile
// sets this to that asset's ref ("clip:SCENE_01_B01_S001") + a human label; the
// ChatPanel consumes it to pre-fill the chat so "reshoot this" knows which shot.
export interface ChatInstructTarget {
  assetRef: string;
  label: string;
}
export const chatInstructAtom = atom<ChatInstructTarget | null>(null);
